<template>
    <div class="reminder-detail-page">
        <headers title="选择通知方式"></headers>
        <div class="send_btn" @click="selectType">确定</div>
        <div class="sendTime">
            <div class="item tongzhi" :class="method==2?'active':''" @click="handleSelect(2)">短信通知</div>
            <div class="item tongzhi" :class="method==1?'active':''" @click="handleSelect(1)">系统通知</div>
        </div>

    </div>
</template>

<script>
import headers from 'COMPONENTS/base/header.vue'
export default {
    components: {
        headers
    },
    data () {
        return {
            method: JSON.parse(localStorage.getItem('notice_method'))
        }
    },
    methods: {
        handleSelect (val) {
            this.method = val;
        },
        selectType () {
            if (this.method === null) {
                layer.tips('选择通知方式')
                return
            }
            localStorage.setItem('notice_method', this.method)
            this.$router.go(-1)
        }
    },
}
</script>

<style lang="scss" scoped>
    .send_btn{
        position: fixed;
        top: 0;
        right: 32px/$ppr;
        font-size: 30px/$ppr;
        line-height: 96px/$ppr;
        color: #fff;
        z-index: 10;
        opacity: 0.8;
    }
    .sendTime {
        .item {
            padding: 24px / $ppr;
            background: #fff;
        }
        .active {
            color: #5e89ef;
            background: #fff url("../release/img/icon-xuanzhong.png") no-repeat 97%
                center;
            background-size: 32px / $ppr 32px / $ppr;
        }
    }
</style>